import React, { useEffect } from 'react';
import { Formik } from 'formik';
import { Form, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import InputField from '../../../../components/form/InputField';
import FormGroup from '../../../../components/form/FormGroup';
import {
  createArtisanJobAction,
  updateArtisanJobAction,
  getArtisanJobsAction
} from '../../../../modules/artisanJobs/Actions';
import {
  artisanJobsIsLoadingSelector,
  artisanJobByIdSelector
} from '../../../../modules/artisanJobs/Selectors';
import FormBIOi18n from '../../../../components/form/i18nForm/FormBIOi18n';
import areas from '../../../../assets/areas.json';

import * as Yup from 'yup';
import { getArtisans } from '../../../../modules/artisans/Api';
import getLangData from '../../../../utils/getLangData';
import { getArtisanCategoriesAction } from '../../../../modules/artisanJobCategories/Actions';
import {
  artisanCategoriesIsLoadingSelector,
  artisanCategoriesListSelector
} from '../../../../modules/artisanJobCategories/Selectors';
import {
  CheckBox,
  MultiInputField,
  SearchableSelect,
  TextArea,
  Select
} from '../../../../components/form';
import { artisansIsLoadingSelector } from '../../../../modules/artisans/Selectors';
import SkillsSearchable from '../../../../components/form/SkillsSearchable';

const schema = () =>
  Yup.object().shape({
    jobCID: Yup.string()
      .default('')
      .required(getLangData().fields.required),
    salary: Yup.string().default(''),
    jobState: Yup.string().default(''),
    jobTitle: Yup.string()
      .default('')
      .required(getLangData().fields.required),
    jobDescription: Yup.string()
      .default('')
      .required(getLangData().fields.required),
    city: Yup.string()
      .default('')
      .required(getLangData().fields.required),
    area: Yup.string()
      .default('')
      .required(getLangData().fields.required),
    yearsOfExperience: Yup.number()
      .default(1)
      .positive('must be positive')
      .required(getLangData().fields.required),
    trainingAvailable: Yup.boolean().default(false),
    skills: Yup.array()
      .default([])
      .required(getLangData().fields.required)
  });

export const jobStateOptions = [
  {
    label: 'وقت كامل',
    value: 'fullTime'
  },
  {
    label: 'دوام جزائي',
    value: 'partTime'
  },
  {
    label: 'يومي',
    value: 'daily'
  },
  {
    label: 'عمل حر',
    value: 'freelance'
  },
  {
    label: 'موسمي',
    value: 'seasonBased'
  }
];
const ArtisanJobsForm = props => {
  const {
    jobId,
    isLoading,
    createArtisanJob,
    updateArtisanJob,
    getArtisanJobs,
    artisanJob,
    getCategories,
    categories,
    categoriesIsLoading,
    currentUser
  } = props;
  const artisanId = currentUser?.profiles?.artisan?._id;

  useEffect(() => {
    console.log(artisanId, 'artisanIdartisanId');
    if (jobId && artisanId) {
      getArtisanJobs({
        artisanId
      });
    }
  }, [getArtisanJobs, jobId, artisanId]);
  const profileLang = getLangData().profile_types;
  const fieldsLang = getLangData().fields;
  const buttonsLang = getLangData().buttons;

  console.log(artisanJob, 'jobId');
  if (jobId) {
    if (!artisanJob) return <div></div>;
  }

  return (
    <Formik
      initialValues={
        artisanJob
          ? { ...artisanJob, skills: artisanJob.skills }
          : schema().cast()
      }
      validationSchema={schema()}
      onSubmit={async values => {
        if (jobId) {
          await updateArtisanJob(jobId, {
            ...values,
            artisanId,
            jobCID: values.jobCID._id,
            jobType: 1
          });
        } else {
          await createArtisanJob({
            ...values,
            artisanId,
            jobCID: values.jobCID._id,
            jobType: 1
          });
        }
      }}
    >
      {({ values, handleSubmit, errors }) => (
        <FormGroup
          errors={errors}
          isLoading={isLoading}
          handleSubmit={handleSubmit}
          heading={
            artisanJob
              ? `${buttonsLang.update} [${artisanJob.jobTitle}]`
              : buttonsLang.create
          }
        >
          <SearchableSelect
            name={'jobCID'}
            label={getLangData().general_words.artisan_categories}
            getItems={getCategories}
            options={categories}
            isLoading={categoriesIsLoading}
            defaultValues={values['jobCID']}
          />
          <InputField label={fieldsLang?.title_job} name='jobTitle' />
          <TextArea
            name='jobDescription'
            label={fieldsLang.descrition_job}
            RTL='rtl'
          />
          <InputField
            label={fieldsLang?.yearsOfExperience}
            name='yearsOfExperience'
            type='number'
          />
          <InputField label={'الراتب'} name='salary' type='text' />
          <Select
            options={jobStateOptions}
            name='jobState'
            label='نوع الوظيفة'
          />
          <CheckBox
            name='trainingAvailable'
            label={fieldsLang.trainingAvailable}
          />
          <SkillsSearchable
            name='skills'
            label={fieldsLang.skills_applicant}
            options={values.skills}
          />
          <Select
            options={Object.keys(areas).map(data => ({
              value: data,
              label: data
            }))}
            name='city'
            label='المدينة'
          />
          {values['city'] && (
            <Select
              options={areas[values['city']]}
              name='area'
              label='المنطقة'
            />
          )}
        </FormGroup>
      )}
    </Formik>
  );
};

const mapStateToProps = (state, props) => {
  const jobId = props.match.params.id;
  return {
    jobId,
    isLoading: artisanJobsIsLoadingSelector(state),
    artisanJob: artisanJobByIdSelector(state, jobId),
    categories: artisanCategoriesListSelector(state),
    artisansIsLoading: artisansIsLoadingSelector(state),
    categoriesIsLoading: artisanCategoriesIsLoadingSelector(state),
    currentUser: state?.users?.currentUser
  };
};

export default connect(mapStateToProps, {
  getArtisanJobs: getArtisanJobsAction,
  createArtisanJob: createArtisanJobAction,
  updateArtisanJob: updateArtisanJobAction,
  getCategories: getArtisanCategoriesAction
})(ArtisanJobsForm);
